// extracted by mini-css-extract-plugin
module.exports = {"consentContainer":"Consent_consentContainer__Vy6dS","consentLabel":"Consent_consentLabel__3Pvqf","consentCheckbox":"Consent_consentCheckbox__JoFqn"};